<script setup>
import {reactive, onMounted, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {FormValidation} from "@/Utils/FormValidation";
import {ToastUtil} from "@/Utils/ToastUtil";

const form = ref(null);

const data = reactive({
  menu: false,
  menu2: false,
  menu3: [],
  dataLoading: true,
  date: null,
  dateFormatted: '',
  newItem: {
    name: '',
    streetaddress: '',
    city: '',
    state: '',
    zip: '',
    mobilephone: '',
    homephone: '',
    email: '',
    emergencycontactname: '',
    emergencycontactnumber: '',
    driverlicensenumber: '',
    driverlicensestate: '',
    formatexpiration: '',
    formatdob: '',
    company: ''
  },
  defaultItem: {
    name: '',
    streetaddress: '',
    city: '',
    state: '',
    zip: '',
    mobilephone: '',
    homephone: '',
    email: '',
    emergencycontactname: '',
    emergencycontactnumber: '',
    driverlicensenumber: '',
    driverlicensestate: '',
    formatexpiration: '',
    formatdob: '',
    company: ''
  },
  loading: false,
  person: [],
  states: [
    'AL',
    'AK',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'MP',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ],
  valid: true,
  licenses: [],
  // licenses: [{licensenumber: null, state: null, formatlicenseexpiration: null}],
});

const reset = () => {
  form.value.reset()
}

const acceptEmergencyContactNumber = () => {
  let x = data.newItem.emergencycontactnumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  data.newItem.emergencycontactnumber = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

const acceptHomeNumber = () => {
  let x = data.newItem.homephone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  data.newItem.homephone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

const acceptMobileNumber = () => {
  let x = data.newItem.mobilephone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  data.newItem.mobilephone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

const formatDate = (date) => {
  if (!date) return null

  return new Date(date).toLocaleDateString();
}

const formatPhoneNumber = (phoneNumberString) => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }
  return null
}

const save = () => {
  data.loading = true;
  ApiWrapper.post('person-form','create-person', {
    newItem: data.newItem,
    licenses: data.licenses
  })
  .then((response) => {
    reset()
    data.loading = false
    ToastUtil.successMsg('Created person');
  })
  .catch((err) => {
    ToastUtil.error(err);
    data.loading = false;
  })
}

onMounted(()=>{
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-toolbar-title>New Applicant Form</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-spacer></v-spacer>
      </v-toolbar>

      <!-- New Person Form -->
      <v-form ref="form" v-model="data.valid" lazy-validation>
        <v-card-title class="v__card__title__color">Personal Information</v-card-title>
        <v-row class="mx-4">
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.name"
                label="Name"
                :rules="[v => !!v || 'Name is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.company"
                label="Company"
                :rules="[v => !!v || 'Company is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
                v-model="data.menu"
                :close-on-content-click="false"
                :return-value="data.newItem.formatdob"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, props }">
                <v-text-field
                    v-model="data.newItem.formatdob"
                    label="DOB"
                    persistent-hint
                    prepend-inner-icon="mdi-calendar"
                    v-bind="props"
                    clearable
                    v-on="on"
                    :rules="[v => !!v || 'DOB is required']"
                    @click="data.date = new Date(data.newItem.formatdob||'')"
                >
                </v-text-field>
              </template>
              <v-date-picker
                  v-model="data.date"
                  scrollable
                  @update:modelValue="data.date=$event;data.newItem.formatdob = formatDate(data.date)"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="mx-4">
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.streetaddress"
                label="Address"
                :rules="[v => !!v || 'Street Address is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.city"
                label="City"
                :rules="[v => !!v || 'City is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
                v-model="data.newItem.state"
                :items="data.states"
                label="State"
                auto-select-first
                :rules="[v => !!v || 'State is required']"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.zip"
                label="Zip Code"
                :rules="[v => !!v || 'Zip is required']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mx-4">
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.homephone"
                label="Home Phone"
                :rules="[FormValidation.phoneRules]"
                @input="acceptHomeNumber"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.mobilephone"
                label="Mobile Phone"
                :rules="[FormValidation.phoneRules]"
                @input="acceptMobileNumber"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.email"
                label="Email"
                :rules="[v => !!v || 'Email is required']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-title class="v__card__title__color">Driver License</v-card-title>
        <v-row class="mx-4">
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.driverlicensenumber"
                label="Driver License Number"
                :rules="[v => !!v || 'Driver License Number is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
                v-model="data.newItem.driverlicensestate"
                label="Driver License State"
                :items="data.states"
                auto-select-first
                :rules="[v => !!v || 'Driver License State is required']"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
                ref="menu2"
                v-model="data.menu2"
                :close-on-content-click="false"
                :return-value="data.newItem.formatexpiration"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, props }">
                <v-text-field
                    v-model="data.newItem.formatexpiration"
                    label="Driver License Exp"
                    persistent-hint
                    prepend-inner-icon="mdi-calendar"
                    v-bind="props"
                    clearable
                    v-on="on"
                    @click="data.date = new Date(data.newItem.formatexpiration||'')"
                    :rules="[v => !!v || 'Driver License Expiration is required']"
                >
                </v-text-field>
              </template>
              <v-date-picker
                  v-model="data.date"
                  scrollable
                  @update:modelValue="data.date=$event;data.newItem.formatexpiration = formatDate(data.date)"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-card-title class="v__card__title__color">Additional Licenses</v-card-title>
        <div v-for="(item, index) in data.licenses" :key="index">
          <v-row class="ml-4">
            <v-col cols="12" sm="3">
              <v-text-field v-model="item.licensenumber" label="License Number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                  v-model="data.menu3[index]"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, props }">
                  <v-text-field
                      v-model="item.formatlicenseexpiration"
                      label="License Expiration"
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="props"
                      clearable
                      @click="data.date = new Date(data.licenses[index].formatlicenseexpiration||'')"
                      v-on="on"
                  >
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="data.date"
                    @update:modelValue="data.date=$event;data.licenses[index].formatlicenseexpiration = formatDate(data.date)"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                  v-model="item.state"
                  :items="data.states"
                  label="State"
                  auto-select-first
                  clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </div>
        <v-btn size="small" variant="elevated" color="primary" class="ml-4" @click="data.licenses.push({licensenumber: null, state: null, formatlicenseexpiration: null})">Add another license</v-btn>
        <v-card-title class="v__card__title__color">Emergency Contact</v-card-title>
        <v-row class="mx-4">
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.emergencycontactname"
                label="Emergency Contact"
                :rules="[v => !!v || 'Emergency Contact is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
                v-model="data.newItem.emergencycontactnumber"
                label="Emergency Contact Number"
                :rules="[FormValidation.phoneRules]"
                @input="acceptEmergencyContactNumber"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-btn
            class="ml-4 mb-2"
            variant="elevated"
            color="primary"
            @click="save"
            :disabled="!data.valid || data.loading"
            :loading="data.loading"
        >
          Submit
        </v-btn>
        <v-btn
            v-if="!data.loading"
            variant="elevated"
            color="success"
            class="ml-2 mb-2"
            @click="reset"
        >
          Reset Form
        </v-btn>
      </v-form>
    </v-card>
  </v-container>
</template>

<style scoped>
[v-cloak] {
  display: none;
}
.v__card__title__color {
  color: #1976D2;
}
</style>